import { faIdCard, faUser, faMapMarkerAlt, faUserFriends, faPhone, faEnvelope, faBuilding } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { EmployeeData } from "./NewEmployeeDetail";

interface PersonalDetailsProps {
  employee: EmployeeData;
}
const PersonalDetails: React.FC<PersonalDetailsProps> = ({ employee }) => {
  console.log("Employee Data in PersonalDetails: ", employee);
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

      <div className="bg-white dark:bg-gray-900 rounded-xl p-5 shadow-sm dark:shadow-gray-900/40 border border-gray-100 dark:border-gray-800 hover:shadow-md dark:hover:shadow-gray-900/60 transition-shadow">
        <h3 className="text-lg font-bold text-gray-800 dark:text-gray-100 mb-4 flex items-center border-b border-blue-100 dark:border-gray-700 pb-3">
          <div className="bg-blue-100 p-2 rounded-lg mr-3">
            <FontAwesomeIcon icon={faIdCard} className="text-blue-600" />
          </div>
          Personal Info
        </h3>
        <div className="space-y-4">
          <div className="flex items-start hover:bg-blue-50 p-2 rounded-lg transition-colors">
            <div className="bg-gray-100 p-2 rounded-lg mr-3">
              <FontAwesomeIcon icon={faUser} className="text-gray-600 w-4" />
            </div>
            <div className="flex-1">
              <div className="text-xs text-gray-400 uppercase font-semibold mb-1">Gender</div>
              <div className="font-semibold text-gray-800 dark:text-gray-200">{employee.gender || "N/A"}</div>
            </div>
          </div>
          <div className="flex items-start hover:bg-blue-50 p-2 rounded-lg transition-colors">
            <div className="bg-gray-100 p-2 rounded-lg mr-3">
              <FontAwesomeIcon icon={faMapMarkerAlt} className="text-gray-600 w-4" />
            </div>
            <div className="flex-1">
              <div className="text-xs text-gray-400 uppercase font-semibold mb-1">Location</div>
              <div className="font-semibold text-gray-800 dark:text-gray-200">{[employee.city, employee.state].filter(Boolean).join(", ") || "N/A"}</div>
            </div>
          </div>
          <div className="flex items-start hover:bg-blue-50 p-2 rounded-lg transition-colors">
            <div className="bg-gray-100 p-2 rounded-lg mr-3">
              <FontAwesomeIcon icon={faUserFriends} className="text-gray-600 w-4" />
            </div>
            <div className="flex-1">
              <div className="text-xs text-gray-400 uppercase font-semibold mb-1">Manager</div>
              <div className="flex flex-col dark:text-gray-200">
                <span className="font-semibold text-gray-800 dark:text-gray-200">{employee.reportingTo || "N/A"}</span>
                <span className="text-gray-800 text-xs dark:text-gray-200">{employee?.managerCode}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Info */}
      <div className="bg-white dark:bg-gray-900 rounded-xl p-5 shadow-sm dark:shadow-gray-900/40 border border-gray-100 dark:border-gray-800 hover:shadow-md dark:hover:shadow-gray-900/60 transition-shadow">
        <h3 className="text-lg font-bold text-gray-800 dark:text-gray-100 mb-4 flex items-center border-b border-blue-100 dark:border-gray-700 pb-3">
          <div className="bg-green-100 p-2 rounded-lg mr-3">
            <FontAwesomeIcon icon={faPhone} className="text-green-600" />
          </div>
          Contact Info
        </h3>
        <div className="space-y-4">
          <div className="flex items-start hover:bg-green-50 p-2 rounded-lg transition-colors">
            <div className="bg-gray-100 p-2 rounded-lg mr-3">
              <FontAwesomeIcon icon={faEnvelope} className="text-gray-600 w-4" />
            </div>
            <div className="flex-1">
              <div className="text-xs text-gray-400 uppercase font-semibold mb-1">Email</div>
              <div className="font-semibold text-gray-800 dark:text-gray-200 break-all">{employee.email || "N/A"}</div>
            </div>
          </div>
          <div className="flex items-start hover:bg-green-50 p-2 rounded-lg transition-colors">
            <div className="bg-gray-100 p-2 rounded-lg mr-3">
              <FontAwesomeIcon icon={faPhone} className="text-gray-600 w-4" />
            </div>
            <div className="flex-1">
              <div className="text-xs text-gray-500 uppercase font-semibold mb-1">Phone</div>
              <div className="font-semibold text-gray-800 dark:text-gray-200">{employee.mobile || "N/A"}</div>
            </div>
          </div>
          <div className="flex items-start hover:bg-green-50 p-2 rounded-lg transition-colors">
            <div className="bg-gray-100 p-2 rounded-lg mr-3">
              <FontAwesomeIcon icon={faBuilding} className="text-gray-600 w-4" />
            </div>
            <div className="flex-1">
              <div className="text-xs text-gray-500 uppercase font-semibold mb-1">Address</div>
              <div className="font-semibold text-gray-800 dark:text-gray-200 break-words">
                {[employee.address, employee.postalCode].filter(Boolean).join(", ") || "N/A"}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default PersonalDetails;